import { createSelector } from '@reduxjs/toolkit';
import { Pair } from 'client/voladeum/pairs/types';
import { RootState } from 'store';

const pairsSlice = (state: RootState) => state.pairs;

export const selectPairs = createSelector([pairsSlice], (state): Pair[] => state);
